import { List, ListItemButton, ListItemText, Paper } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Fragrance } from '~/api/api.declaration';
import { AppRoutes } from '~/app/app.routes';
import { FragranceCreateDto } from '~/shared/dto/admin/fragrance.dto';
import { Form } from '~/shared/form';

type FragranceClaspedProps = {
	form: Form<FragranceCreateDto, Fragrance>;
};

export const FragranceClasped = observer<FragranceClaspedProps>(({ form }) => {
	return (
		<List>
			{form.initial?.clasped?.map(c => (
				<Paper key={c.id}>
					<ListItemButton onClick={() => window.open(AppRoutes.FragranceEdit.buildPath({ id: c.id }))}>
						<ListItemText primary={c.name} secondary={c.id} />
					</ListItemButton>
				</Paper>
			))}
		</List>
	);
});
